export const blockIconsFileUploadFile = (
	<span className='material-symbols-outlined'>upload_file</span>
);
